// Free, seeded "opening challenge" verses for the daily Wada Baila challenge.
// One is picked each day by day-of-year. No AI cost.
export const BAILA_CHALLENGES = {
  si: [
    "මම තමයි ගමේ බයිලා රජා,\nඔයාට බෑ මාව පරදවන්න මචා!",
    "තේ එකක් බීලා පදයක් කියන්න,\nමං වගේ ගයන්නෙ බෑ කවුරුත් දිනන්න!",
    "හඳ පායනවා අහසේ රෑට,\nඔයාගෙ පදෙ නම් වැටෙයි පොළොවට!",
    "නටනවා නම් නටපන් මා එක්ක,\nපදෙන් නම් ඔයා පරදියි ලැජ්ජාවට!",
    "ගමේ ලස්සනම කෙල්ල මං කියනවා,\nඔයාගෙ පදවල් නම් ඈත පලයනවා!",
    "රබාන ගහන්න, තාලෙට කියන්න,\nමගෙ බයිලාවට ඔයා බෑ ළං වෙන්න!",
    "අවුරුද්දට කැවුම් වගේ මිහිරී,\nමගෙ පදවල් ඔයාට වෙයි ලොකු පීඩාවක්!",
    "කවි කියනවා නම් හරියට කියපන්,\nනැත්තං ගෙදර ගිහින් නිදාගනින්!",
  ],
  en: [
    "I'm the baila king of this whole town,\nYou try to beat me — you'll only go down!",
    "Sip your tea and sing a line,\nbut none can out-sing this voice of mine!",
    "The moon comes up so bright at night,\nyour weak little verse just floats out of sight!",
    "If you want to dance, then dance with me,\nbut in verse you'll lose — just wait and see!",
    "They call me the sweetest voice around,\nyour rhymes run away without a sound!",
    "Beat the drum and keep the time,\nyou'll never catch this baila of mine!",
    "Sweet as sweetmeats at New Year's dawn,\nmy verses will leave your bragging gone!",
    "If you can sing, then sing it right,\nor go back home and sleep tonight!",
  ],
};
